
/* eslint-disable vue/no-reserved-component-names,vue/multi-word-component-names */
import { CardFrame } from './style'
import VueTypes from 'vue-types'
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Cards',
  components: {
    CardFrame
  },
  props: {
    title: VueTypes.oneOfType([VueTypes.string, VueTypes.object]),
    size: VueTypes.oneOf(['default', 'small']).def('default'),
    more: VueTypes.bool.def(false),
    bodyStyle: VueTypes.object,
    headStyle: VueTypes.object,
    headless: VueTypes.bool.def(false),
    border: VueTypes.bool.def(false),
    caption: VueTypes.string,
    bodypadding: VueTypes.string,
    moreText: VueTypes.bool.def(false)
  }
})
